import { StatusModel } from "@components/classes/TransactionStatusClass";

class UserManagementClasses {
  private categoryStyleMap = new Map<string, StatusModel>([
    [
      "individual",
      {
        textColor: "#FE961C",
        bgColor: "bg-[#FFF0E4]",
      },
    ],
    [
      "affiliate",
      {
        textColor: "#BE185D",
        bgColor: "bg-[#FBCFE8]",
      },
    ],
    [
      "cashier",
      {
        textColor: "#1D4ED8",
        bgColor: "bg-[#C7DBFF]",
      },
    ],
    [
      "institutional",
      {
        textColor: "#686E92",
        bgColor: "bg-[#F1F3F5]",
      },
    ],
    [
      "small_merchant",
      {
        textColor: "#66AD7B",
        bgColor: "bg-[#E2F6E8]",
      },
    ],
    [
      "settlement",
      {
        textColor: "#66AD7B",
        bgColor: "bg-[#E2F6E8]",
      },
    ],
    [
      "personal",
      {
        textColor: "#0F766E",
        bgColor: "bg-[#BDEFEA]",
      },
    ],
    [
      "merchant",
      {
        textColor: "#7C3AED",
        bgColor: "bg-[#E2D4FF]",
      },
    ],
  ]);

  /** Always returns a valid style */
  getCategoryStyle(category?: string): StatusModel {
    return (
      this.categoryStyleMap.get(category ?? "") ?? {
        textColor: "#686E92",
        bgColor: "bg-[#F1F3F5]",
      }
    );
  }

  updateDeleteButton = ({
    onUpdate,
    onCancel,
    isDirty,
  }: {
    onUpdate: () => void;
    onCancel: () => void;
    isDirty: boolean;
  }) => {
    return (
      <div className="flex flex-row px-[8px] py-[8px] justify-between items-center gap-[16px]">
        <div
          className="bg-bg-status-red rounded-[8px] py-[8px] w-[50%] text-[12px] font-semibold text-center cursor-pointer"
          onClick={onCancel}>
          CANCEL
        </div>
        <div
          className={`
    rounded-[8px] py-[8px] w-[50%] text-[12px] font-semibold text-center
    ${
      isDirty
        ? "bg-bg-status-green cursor-pointer"
        : "bg-gray-300 cursor-not-allowed"
    }
  `}
          onClick={isDirty ? onUpdate : undefined}>
          UPDATE
        </div>
      </div>
    );
  };
}

export default UserManagementClasses;
